import { Button } from '@folio/components/ui/button';
import { Spinner } from '@folio/components/ui/spinner';
import type { DocumentClassificationState } from 'korint-sdk/react';
import { useTranslation } from 'react-i18next';

const PROCESSING_STATUSES: ReadonlySet<DocumentClassificationState['status']> = new Set([
  'validating',
  'validated',
  'scanning',
  'scan_complete',
  'classifying',
  'classified',
  'extracting',
  'checking_validity',
  'validity_checked',
]);

export function isDocumentClassificationProcessing(
  state: DocumentClassificationState | undefined,
): boolean {
  return state ? PROCESSING_STATUSES.has(state.status) : false;
}

export function isDocumentProcessing({
  classification,
  extractionStatus,
  validityStatus,
}: {
  classification?: DocumentClassificationState;
  extractionStatus?: string;
  validityStatus?: string;
}): boolean {
  return (
    isDocumentClassificationProcessing(classification) ||
    extractionStatus === 'PENDING' ||
    validityStatus === 'PENDING'
  );
}

export function DocumentProcessingStatus({ onOpen }: { onOpen?: () => void }) {
  const { t } = useTranslation();

  return (
    <Button
      variant="ghost"
      size="sm"
      disabled={!onOpen}
      onClick={onOpen}
      leftIcon={<Spinner className="size-3.5 text-current" />}
    >
      {t('documentReview.status.processing')}
    </Button>
  );
}
